import { render, staticRenderFns } from "./FormatAdminForm.vue?vue&type=template&id=0f645864"
import script from "./FormatAdminForm.vue?vue&type=script&lang=js"
export * from "./FormatAdminForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports